export default "__VITE_ASSET__4a76ff62__"